import * as Yup from 'yup';
import { useState, useContext } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate } from 'react-router-dom';
import { mask, unMask } from "remask";

// material
import { Stack, TextField, Alert, MenuItem} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { ThemeProvider } from '@mui/material/styles';
import Theme from '../../../components/Button';

import {api, reiniciarToken, cadastrarEmpresa} from '../../../services/api';

// context
import { AuthContext } from '../../../contexts/auth';

// ----------------------------------------------------------------------

export default function CadEmpresaForm() {

  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const [status, setStatus] = useState({
    type: '',
    mensagem: ''
  })

  const RegisterSchema = Yup.object().shape({
    descricao: Yup.string().min(2, 'Muito Pequeno!').max(500, 'Muito Longo!').required('Descrição é obrigatório'),
    contato: Yup.string().required('Contato é obrigatório'),
    telefone_celular: Yup.string().required('Telefone Celular é obrigatório'),
    tipo_comercio: Yup.string().required('Tipo Comércio é obrigatório'), 
  });

  const formik = useFormik({
   initialValues: {
        descricao: '',
        contato: '',
        telefone_celular: '',
        tipo_comercio: '',
        descricao_curta: ''
    },
    validationSchema: RegisterSchema,
    onSubmit: () => {
      navigate('/dashboard', { replace: true });
    },
  });

  const handleSubmit = async e => {
    e.preventDefault();

    const retorno = await reiniciarToken();
    if(retorno.erro === true) {
      if (retorno.mensagem === 'O Token é inválido!' || retorno.mensagem === 'Acesso negado!'){
        logout();
      }
    }else{
      localStorage.setItem("token", retorno.data.token);
      api.defaults.headers.Authorization = `Bearer ${retorno.data.token}`;
    }

    const response = await cadastrarEmpresa(formik.values);

    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!'){
        logout();
      }else {
        setStatus({
          type: "erro",
          mensagem: response.mensagem
        })
      }
    }else {
      setStatus({
        type: "success",
        mensagem: response.data.mensagem
      })
    }; 
  }

  const { errors, touched, isSubmitting, getFieldProps, handleChange, handleBlur} = formik;
  
  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField 
              fullWidth
              label="Descrição"
              {...getFieldProps('descricao')}
              error={Boolean(touched.descricao && errors.descricao)}
              helperText={touched.descricao && errors.descricao}
            />
            <TextField 
              fullWidth
              label="Descrição Resumida"
              {...getFieldProps('descricao_curta')}
              error={Boolean(touched.descricao_curta && errors.descricao_curta)}
              helperText={touched.descricao_curta && errors.descricao_curta}
            />
          </Stack>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField 
              fullWidth
              label="Contato"
              {...getFieldProps('contato')}
              error={Boolean(touched.contato && errors.contato)}
              helperText={touched.contato && errors.contato}
            />
            <TextField
              fullWidth
              label="Telefone Celular"
              {...getFieldProps('telefone_celular')}
              error={Boolean(touched.telefone_celular && errors.telefone_celular)}
              helperText={touched.telefone_celular && errors.telefone_celular}
              onChange={handleChange}
              onBlur={handleBlur}
              value={mask(unMask(formik.values.telefone_celular), '(99)9.9999-9999')}
            />
            <TextField 
              select
              fullWidth
              label="Tipo Comércio"
              {...getFieldProps('tipo_comercio')}
              error={Boolean(touched.tipo_comercio && errors.tipo_comercio)}
              helperText={touched.tipo_comercio && errors.tipo_comercio}
            >
              <MenuItem value ="1">Empresa de Serviços</MenuItem>
              <MenuItem value ="2">Restaurante/Lanchonete</MenuItem> 
              <MenuItem value ="3">Lojas em Geral</MenuItem>
              <MenuItem value ="4">Empresas com Vendas/Despesa Venda</MenuItem>
              <MenuItem value ="5">Agências de Viagem</MenuItem>
              <MenuItem value ="6">Empresas com Templates/Produto</MenuItem>
            </TextField>
          </Stack>
          
          <Stack spacing={3}>
            {status.type === 'erro' ? <Alert severity="error">{status.mensagem}</Alert> : ""}
            {status.type === 'success' ? <Alert severity="success">{status.mensagem}</Alert> : ""}
          </Stack>

          <ThemeProvider theme={Theme}>
            <LoadingButton fullWidth size="large" type="submit" variant="contained" color="neutral" loading={isSubmitting}>
              Cadastrar
            </LoadingButton>
          </ThemeProvider>
        </Stack>  
      </Form>
    </FormikProvider>
  );
}
